//TODO: Port this to college-common repository (constants/areasOfStudy.ts)
export const areasIconsMap = new Map([
  ['1', 'animal-and-plant.svg'],
  ['3', 'natural-resource.svg'],
  ['4', 'architecture-and-related-services.svg'],
  ['5', 'gender-and-groups.svg'],
  ['9', 'communication-and-journalism.svg'],
  ['10', 'support-service.svg'],
  ['11', 'computer-science.svg'],
  ['12', 'culinary.svg'],
  ['13', 'education.svg'],
  ['14', 'engineering.svg'],
  ['15', 'engineering-related-technologies.svg'],
  ['16', 'foreign-languages.svg'],
  ['19', 'human-science.svg'],
  ['22', 'legal.svg'],
  ['23', 'literature.svg'],
  ['24', 'liberal.svg'],
  ['25', 'library.svg'],
  ['26', 'biomedical.svg'],
  ['27', 'math-and-statistic.svg'],
  ['28', 'military.svg'],
  ['29', 'rocket.svg'],
  ['30', 'multi-studies.svg'],
  ['31', 'recreation.svg'],
  ['32', 'basic-skills.svg'],
  ['33', 'citizenship.svg'],
  ['34', 'health-skills.svg'],
  ['35', 'social-skills.svg'],
  ['36', 'leisure.svg'],
  ['37', 'self-improvement.svg'],
  ['38', 'philosophy.svg'],
  ['39', 'religious.svg'],
  ['40', 'physical-sciences.svg'],
  ['41', 'science-technology.svg'],
  ['42', 'psychology.svg'],
  ['43', 'homeland-security.svg'],
  ['44', 'public-administration.svg'],
  ['45', 'social-science.svg'],
  ['46', 'construction-trades.svg'],
  ['47', 'repair-technologies.svg'],
  ['48', 'precision-production.svg'],
  ['49', 'transportation.svg'],
  ['50', 'visual-art.svg'],
  ['51', 'health-and-related.svg'],
  ['52', 'business-marketing.svg'],
  ['53', 'certification.svg'],
  ['54', 'history.svg'],
  ['60', 'medical-residency.svg'],
  ['61', 'health.svg'],
]);
